module.exports = __webpack_public_path__ + "static/img/motiverse_logo-hor.59a2567b.png";